export default __webpack_public_path__ + "56ef6aab774c04274abe1ead999f267d.png";